import type { CapiProductPage } from 'types/capi/pdp';

import Countdown from '~/components/Countdown';
import ProductNotificationButton from '~/components/ProductNotificationButton';
import { getStockStatusConfig } from '~/domain/stockStatus';
import { formatReleaseDateLong } from '~/utils/dates';

import ProductNotificationCount from '../../ProductNotificationCount';

type Props = {
  isNotified: boolean;
  product: CapiProductPage;
};

export default function NotificationCta({ product, isNotified }: Props) {
  return (
    <div className="flex w-full flex-col gap-4 rounded-lg bg-white p-4">
      {product.stock_status === 'sold-out' ? (
        <SoldOutStatus />
      ) : (
        <ComingSoonStatus releaseDate={product.date.released} />
      )}
      {product.allow_user_notifications && (
        <div className="flex flex-col gap-2">
          <ProductNotificationButton
            product={{
              id: product.product_id,
              image: product.gallery[0],
              legacyId: product.legacy_id,
              name: product.name,
              price: product.price.regular
            }}
            className="z-10 h-12 w-full text-center"
            pagePosition="WTB"
            buttonStyle="normal"
          />
          <Tooltip
            numOfNotifications={product.weekly_notifications_count}
            isNotified={isNotified}
          />
        </div>
      )}
    </div>
  );
}

function ComingSoonStatus({ releaseDate }: { releaseDate?: number }) {
  const config = getStockStatusConfig('coming-soon');

  return (
    <div className="flex justify-between">
      <div>
        <div className={`${config?.textColourClass} text-base`}>
          Coming soon
        </div>
        <div className="text-sm">
          {releaseDate ? formatReleaseDateLong(releaseDate) : 'TBC'}
        </div>
      </div>
      {releaseDate && <Countdown toUnixTimestamp={releaseDate} />}
    </div>
  );
}

function SoldOutStatus() {
  const config = getStockStatusConfig('sold-out');

  return (
    <div className="flex justify-between">
      <div>
        <div className={`${config?.textColourClass} text-base`}>
          {config?.text}
        </div>
      </div>
    </div>
  );
}

function Tooltip({
  numOfNotifications,
  isNotified
}: {
  isNotified: boolean;
  numOfNotifications?: number;
}) {
  if (isNotified) return null;

  return (
    <div className="translate-y-[-120%] animate-slide-from-top text-clip">
      {numOfNotifications && numOfNotifications > 50 ? (
        <ProductNotificationCount count={numOfNotifications} />
      ) : (
        <div className="bg-purple-hola-lm p-2 text-center text-xs text-purple-hola">
          Get a release alert
        </div>
      )}
    </div>
  );
}
